module.exports = __webpack_public_path__ + "img/gyl_Android.ce0d464e.png";